/** Favourite pages: a synced workspace setting (JSON array of page ids). */
import type { Store } from '@nexus/store';
import { useStoreQuery } from '../db/context';

const KEY = 'favorites';

async function read(store: Store): Promise<string[]> {
  try {
    const value = JSON.parse((await store.getSetting(KEY)) ?? '[]') as unknown;
    return Array.isArray(value) ? value.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return [];
  }
}

export function useFavorites(): string[] {
  return useStoreQuery(read, [], ['settings']) ?? [];
}

export async function toggleFavorite(store: Store, pageId: string): Promise<void> {
  const list = await read(store);
  const next = list.includes(pageId) ? list.filter((id) => id !== pageId) : [...list, pageId];
  await store.setSetting(KEY, JSON.stringify(next));
}
